import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ENUM_SmartSearchPropertyPurchaseType } from '@api-new/common';
import { ButtonWithImageComponent } from '@shared-lib/components/button-with-image/button-with-image.component';
import { StepperComponent } from '@shared/components/stepper/stepper.component';

@Component({
  selector: 'cp-add-smart-search-new-property-purchase-type-selection',
  imports: [StepperComponent, ButtonWithImageComponent],
  templateUrl: './add-smart-search-new-property-purchase-type-selection.component.html',
  styleUrls: ['../add-smart-search-dialog-step.component.scss', './add-smart-search-new-property-purchase-type-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddSmartSearchNewPropertyPurchaseTypeSelectionComponent implements OnInit {
  @Input({ required: true }) formGroupName: string;
  @Input() showFirstTimeBuyerButton = true;
  @Input() isBackButtonVisible = true;
  @Output() nextClicked = new EventEmitter();
  @Output() backClicked = new EventEmitter();

  private readonly rootFormGroup = inject(FormGroupDirective);

  protected stepFormGroup: FormGroup;
  protected readonly ENUM_SmartSearchPropertyPurchaseType = ENUM_SmartSearchPropertyPurchaseType;

  ngOnInit(): void {
    this.stepFormGroup = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }

  setValue(type: ENUM_SmartSearchPropertyPurchaseType): void {
    this.stepFormGroup.setValue({ type });
  }

  emitNextClicked(): void {
    if (this.stepFormGroup.valid) {
      this.nextClicked.emit();
    }
  }

  emitBackClicked(): void {
    this.backClicked.emit();
  }
}
